import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  NAME: () => FORM_FIELDS.NAME,
};
